import { render, staticRenderFns } from "./GeneratedContentDetails.vue?vue&type=template&id=0113cb80&"
import script from "./GeneratedContentDetails.vue?vue&type=script&lang=js&"
export * from "./GeneratedContentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports